module.exports = __webpack_public_path__ + "assets/img/pt-3b404fc5.png";